{
  "title": "Speak with Dead",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level necromancy",
  "level": 3,
  "castingTime": "1 action",
  "range": "10 feet",
  "components": "V, S, M (burning incense)",
  "duration": "10 minutes",
  "description": [
    "You grant the semblance of life and intelligence to a corpse of your choice within range, allowing it to answer the questions you pose. The corpse must still have a mouth and can’t be undead. The spell fails if the corpse was the target of this spell within the last 10 days.",
    "Until the spell ends, you can ask the corpse up to five questions. The corpse knows only what it knew in life, including the languages it knew. Answers are usually brief, cryptic, or repetitive, and the corpse is under no compulsion to offer a truthful answer if you are hostile to it or it recognizes you as an enemy. This spell doesn’t return the creature’s soul to its body, only its animating spirit. Thus, the corpse can’t learn new information, doesn’t comprehend anything that has happened since it died, and can’t speculate about future events."
  ],
  "spellLists": ["bard", "cleric", "wizard"]
}
